<template>
  <WhatsAppSettings type="REPORT_MEDICINE" />
</template>

<script>
import WhatsAppSettings from "../templates/WhatsApp/WhatsAppSettings";

export default {
  name: "WhatsAppSettingsReportMedicine",

  components: {
    WhatsAppSettings,
  },
};
</script>